import { useEffect, useContext } from 'react';
import Cookies from 'universal-cookie';
import { Link, useNavigate } from 'react-router-dom';
import "../../style/startPage.css"
import {PageTreeContext} from "../../context/pageTreeContext"
import Footer from '../Footer';
import MenuItem from "./menuItem"
import {LERNEINHEITEN_SVG_URL, INHALTINFO_SVG_URL, TECHNISCHEINFO_SVG_URL, BOOKMARK_SVG, techIntroPageID, contentIntroPageID, jwtName} from "../../constants"

export default function StartPage(){
    const pageTreeContextValue = useContext(PageTreeContext);
    const cookies = new Cookies()
    const navigate = useNavigate();

    useEffect(() => {
        const jwt = cookies.get(jwtName)
            if(!jwt){
                navigate('/')
            } else {
                pageTreeContextValue.amILoggedIn()
                pageTreeContextValue.changeIsBreadcrumbsVisible(false)
            }
        
    }, [])

    return (
        <div className='startPagePlusFooter'>
            <div className='startPage  '>
                <MenuItem name={"Lerneinheiten"} linkTo={"/lerneinheiten"} svgSource={LERNEINHEITEN_SVG_URL} />
                <MenuItem name={"Lesezeichen"} linkTo={"/favorites/pages"} svgSource={BOOKMARK_SVG}/>
                <MenuItem name={"Technische Einführung"} linkTo={'/lerneinheiten/page/' + techIntroPageID} svgSource={TECHNISCHEINFO_SVG_URL} />
                <MenuItem name={"Inhaltliche Einführung"} linkTo={'/lerneinheiten/page/' + contentIntroPageID} svgSource={INHALTINFO_SVG_URL} />
            </div>
            <Footer />  
        </div>
        
    )
}

